// UI
import ArtistListHeader from './ArtistListHeader'

export default ArtistListHeader